<!-- 签到有礼-首页 -->
<template>
  <div
    class="sign-in-gift-index"
    :style="{
      background: `url(${actInfo.backImage}) no-repeat  #efefef`,
      'background-size': `100% auto`,
    }"
  >
    <div class="title-box">
      <h4>签到领好礼</h4>
      <p>{{ signNameObj.l }}签到，赢取多重惊喜奖励！</p>
    </div>
    <!-- 进度条 -->
    <div class="progress-box">
      <div class="title-row">{{ signNameObj.s }}签奖励</div>
      <ul class="stage-content">
        <li class="stage-start">
          <div class="circle"></div>
        </li>
        <li
          v-for="item in progressData"
          :key="item.id"
          :class="{
            'stage-box': true,
            'end-stage': item.isEnd,
          }"
        >
          <div :class="{ line: true, 'reach-line': item.isReach }"></div>
          <template v-if="!item.isEnd">
            <img
              :src="
                require(`@/assets/imgs/scenario/signInGift/icon${item.id % 3}${
                  item.isReach ? '_a' : ''
                }.png`)
              "
              alt=""
            />
            <span class="text">{{ signNameObj.s }}签{{ item.value }}天</span>
          </template>
          <div v-if="item.nextTarget" :class="[`bubble-tip `]">
            再{{ signNameObj.l }}签到{{
              item.value - userInfo.signInGiftCount
            }}天得好礼
          </div>
        </li>
      </ul>
    </div>

    <!-- 日历 -->
    <div class="calendar-box">
      <header>
        <span class="text"
          >已{{ signNameObj.l }}签到{{ userInfo.signInGiftCount }}天</span
        >
        <div @click="toRecord" class="my-prize">
          <img src="@/assets/imgs/scenario/signInGift/pic9.png" alt="" />
          <span>我的奖品</span>
        </div>
      </header>
      <div class="switch-button-box">
        <van-icon
          name="play"
          :class="{ left: true, disabled: preDisabed }"
          @click="switchMouth(1)"
        />
        <span>{{ showTitle }}</span>
        <van-icon
          name="play"
          :class="{ right: true, disabled: nextDisabed }"
          @click="switchMouth(2)"
        />
      </div>
      <van-calendar
        title="日历"
        :poppable="false"
        :show-confirm="false"
        :show-mark="false"
        :show-title="false"
        :show-subtitle="true"
        :readonly="true"
        :min-date="minDate"
        :max-date="maxDate"
        :default-date="defaultDate"
        :formatter="formatter"
      />
      <!-- 立即签到按钮 -->
      <div class="calendar-footer">
        <van-button
          v-if="signBtnInfo.text"
          type="primary"
          :color="signBtnInfo.disabled ? '#D6D6D6' : '#FF2B21'"
          loading-text="签到中..."
          :disabled="signBtnInfo.disabled"
          :loading="signBtnInfo.loading"
          round
          block
          @click="signInFun"
          >{{ signBtnInfo.text }}</van-button
        >
        <div class="dog-ear">
          <img src="@/assets/imgs/scenario/signInGift/pic2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="rule-box">
      <h4>
        <img
          src="@/assets/imgs/scenario/signInGift/pic6.png"
          class="icon pre"
          alt=""
        />
        <span>签到活动规则</span>
        <img
          src="@/assets/imgs/scenario/signInGift/pic6.png"
          class="icon next"
          alt=""
        />
      </h4>
      <p>{{ actInfo.ruleDescribe }}</p>
    </div>

    <!-- 结果弹窗 -->
    <ResultPopup ref="resultPopupRef" />
  </div>
</template>
<script setup>

import { reactive, ref, computed, onMounted, defineExpose, defineEmits, nextTick } from 'vue'
import ResultPopup from './components/ResultPopup.vue'
import moment from 'moment'
import { Toast } from 'vant';
import { useRoute, useRouter, } from "vue-router";
import {
  login,
  getUserInfo,
  getSignActInfo,
  getSignInGiftCount,
  getSignInMothRecord,
  signIn,
} from '@/api/signInGift.js'
import anime from 'animejs/lib/anime.es.js';

const route = useRoute();
const router = useRouter();

// 测试
// sessionStorage.setItem('signInGiftToken', '1404a5494f234d66a7261cb8de6f87f2')


const resultPopupRef = ref()
const defaultDate = ref(null) // 默认选中日期
// 在 iOS 系统上初始化组件失败？
// 如果你遇到了在 iOS 上无法渲染组件的问题，请确认在创建 Date 对象时没有使用new Date('2020-01-01')这样的写法，iOS 不支持以中划线分隔的日期格式，正确写法是new Date('2020/01/01')
const minDate = ref(new Date())  // 展示日历的最小日期
const maxDate = ref(new Date()) // 展示日历的最大日期
const showTitle = ref('') // // 展示日历的标题
const nextDisabed = ref(false) // 下个月按钮是否禁用
const preDisabed = ref(false) // 上个月按钮是否禁用
const today = ref(moment().format('YYYY-MM-DD')) // 当天日期
const signedInArr = ref([]) // 已签到数组 比如：'2024-01-15'
const notSignedInArr = ref([]) // 未签到数组 比如：'2024-01-15'

const progressData = ref([
]) // 进度条 isEnd: true 表示已结束，isReach: true 表示已达到签到天数  nextTarget 下一个目标
const platformType = ref([]) // 发券平台集合，例如'zfb'
const platformFormData = ref({})
const signActId = ref('') // 签到活动id
const actInfo = ref({
  startTime: '',
  endTime: '',
  prizeInfoList: [],
  ruleDescribe: '',
  activityStatus: '', // 0未开始 1进行中 2已结束
  signType: '', // 签到类型 1连续签到 2累计签到
}) // 活动信息
const userInfo = ref({
  phone: '',
  signInGiftCount: 0, // 已签到天数
}) // 用户信息
const signActInfo = ref({}) // 签到活动信息
const signBtnInfo = reactive({
  text: '',
  disabled: false,
  loading: false,
}) // 签到按钮状态


const signNameObj = computed(() => {
  if (actInfo.value.signType === 1) {
    return {
      s: '连',
      l: '连续',
    }
  }
  if (actInfo.value.signType === 2) {
    return {
      s: '累',
      l: '累计',
    }
  }
  return {}
}); // 连续or累计名词区分



onMounted(() => {
  sessionStorage.setItem('scenSignInGiftQuery', JSON.stringify(route.query)) // 缓存首页参数，其他页面登录失效的时候，将参数带回
  let _signActId = route.query.signActId
  if (!_signActId) {
    // 都没有signActId的情况下，提示不合法
    return Toast('请携带抽奖有礼ID')
  }
  signActId.value = _signActId
  if (sessionStorage.getItem('signInGiftToken')) {
    getInfo()
  } else {
    loginFun()
  }
})

// 登录
const loginFun = () => {
  const parames = {
    bizNo: signActId.value,
    code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode')
  };
  login(parames).then(async (res) => {
    sessionStorage.setItem('signInGiftToken', res.data)
    getInfo()
  });
}
const getInfo = async () => {
  await getSignInGiftCountFun() // 已签到天数
  await getSignActInfoFun() // 获取活动信息
  switchMouth(0) // 日历天数设置
  setProgressData() // 设置进度条数据
}
const signInFun = () => {
  signBtnInfo.loading = true
  signIn({}).then(res => {
    // 测试数据
    // let res = { "code": 0, "data": null, "message": "操作成功" }

    // let res = { "code": 0, "data": [{ "account": "", "createTime": "2025-01-17 09:50:26", "errorInfo": "", "id": 8, "openId": "oHGftvsJr2y4i8-V6MpYm_-8YeOc", "orderNo": "SPO20250117095026000012", "orderStatus": 4, "orderType": 3, "phone": "", "prizeInfoId": 10, "prizeName": "易积分", "prizeNo": "YJFnJjOF6", "sendNum": 10, "sendPlatform": null, "signActId": "m5yqdprs", "signInNo": "SIR20250117095026000014", "siteName": "新增一个积分微站", "thirdOrderNo": "", "upToPrize": "连续签到3天", "updateTime": null, prizeImage1: "https://elife-dev.oss-cn-shanghai.aliyuncs.com/20250113/20250113160310Ib1i.jpg" }], "message": "操作成功" }


    signBtnInfo.loading = false
    signBtnInfo.text = '已签到'
    signBtnInfo.disabled = true

    let obj = {
      title: '签到成功',
      sub: '',
    }

    if (res.data && res.data.length) {
      // 中奖
      obj.sub = `签到获得的奖品可前往“签到页面-我的奖品”查看`
      obj.icon = res.data[0].prizeImage
      obj.toRecord = true
    } else {
      getSignInGiftCountFun() // 已签到天数获取
    }
    resultPopupRef.value.handleOpen(obj)
    // 弹窗动画-从底部小变大出现
    nextTick(() => {
      anime({
        targets: '.result-popup',
        bottom: ['0%', '30%'],
        scale: [0, 1],
        duration: 300,
        easing: 'easeInOutSine',
      })
    })

  }).catch(() => {
    signBtnInfo.loading = false
  })
}
// 获取活动信息
const getSignActInfoFun = () => {
  return new Promise((resolve, reject) => {
    getSignActInfo({}).then(res => {
      actInfo.value = res.data
      // 活动无效
      if ([0, 2].includes(actInfo.value.activityStatus)) {
        let obj = {
          0: '未开始',
          1: '进行中',
          2: '已结束'
        }
        signBtnInfo.text = obj[actInfo.value.activityStatus]
        signBtnInfo.disabled = true
      }
      document.title = actInfo.value.activityTitle
      resolve()
    })
  })
}
// 月签到记录 (mothFirstDate, type: 0: 当前月，1：上个月，2：下个月, 3：指定年月)
const getSignInMothRecordFun = (mothFirstDate, type) => {
  getSignInMothRecord({
    // signActId: signActId.value,
    mothFirstDate: moment(mothFirstDate).format('YYYY-MM-DD'),
  }).then(res => {
    signedInArr.value = res.data
    // 未签到天数集合=当前月所有日期集合排除已签到的日期
    /**
  ## 开始时间(谁大取谁)
  + 月开始
  + 活动开始
  
  ## 结束时间 (谁小取谁)
  + 月结束
  + 今天
  + 活动结束
  */
    let start = moment(minDate.value)
    let end = moment(maxDate.value)
    let { startTime, endTime } = actInfo.value
    // 开始时间(谁大取谁)
    if (start.isSameOrBefore(moment(startTime))) {
      start = moment(startTime)
    }
    // 结束时间 (谁小取谁)
    if (moment(today.value).isSameOrBefore(end)) {
      end = moment(today.value)
    }
    if (moment(endTime).isSameOrBefore(end)) {
      end = moment(endTime)
    }
    const allDates = []
    let current = start.clone()

    while (current.isSameOrBefore(end)) {
      allDates.push(current.format('YYYY-MM-DD'))
      current.add(1, 'days')
    }

    // 未签到日期 = 范围日期 - 已签到日期
    notSignedInArr.value = allDates.filter(date => {
      return !signedInArr.value.includes(date)
    })
    // 当月 & 活动进行中
    if (type === 0 && actInfo.value.activityStatus === 1) {
      if (signedInArr.value.includes(today.value)) {
        signBtnInfo.text = '已签到'
        signBtnInfo.disabled = true
      } else {
        signBtnInfo.text = '立即签到'
        signBtnInfo.disabled = false
      }

    }
    // console.log(allDates, 'allDates==');
    // console.log(notSignedInArr, 'notSignedInArr==');
  })
}
// 已签到天数
const getSignInGiftCountFun = () => {
  return new Promise((resolve, reject) => {
    getSignInGiftCount({
      // signActId: signActId.value,
    }).then(res => {
      userInfo.value = {
        ...userInfo.value,
        signInGiftCount: res.data
      }
      resolve()
    })
  })
}
// 获取用户信息: 手机号头像昵称
const getUserInfoFun = () => {
  getUserInfo({}).then(res => {
    userInfo.value = res.data
  })
}
// 设置进度条数据
const setProgressData = () => {
  let arr = []
  let { prizeInfoList } = actInfo.value
  let { signInGiftCount } = userInfo.value

  arr = prizeInfoList.map((i, index) => {
    return {
      id: i.id,
      value: i.signDays,
      isReach: signInGiftCount >= i.signDays
    }
  })
  const isReachLength = arr.filter(i => i.isReach).length
  let one = arr.find(i => !i.isReach)
  if (one && one.value) {
    one.nextTarget = true // 下一个目标
  }

  // 尾部
  arr.push({
    id: 'end',
    isEnd: true,
    isReach: false
  })

  progressData.value = arr
  // 进度条动画
  nextTick(() => {
    // 进度条滚动
    setTimeout(() => {
      const scrollableDiv = document.querySelector('.stage-content');
      scrollableDiv.scrollTo({
        left: (isReachLength - 1) * 90,
        behavior: 'smooth'
      });
    }, 100)

    // 进度条增长
    anime({
      targets: '.progress-box .reach-line',
      width: '100%', // -> from '0' to '100%',
      delay: anime.stagger(100),
      complete: function (anim) {
        // console.log(anim);
        // 达到目标弹窗显示
        anime({
          targets: '.bubble-tip',
          opacity: [
            { value: 0, easing: undefined, duration: 0 },
            { value: 1, easing: 'easeInOutQuad', duration: 600 }
          ],
        });
      }
    });
  })

}

// 设置日历数据
// 当前月 type： 0: 当前月，1：上个月，2：下个月, 3：指定年月
// dateStr 指定的年月，格式 “2024-10”
const switchMouth = (type, dateStr) => {
  let _minDate = ''
  let _maxDate = ''
  switch (type) {
    case 0: // 当前月
      _minDate = moment().startOf('month').format('YYYY/MM/DD')
      _maxDate = moment().endOf('month').format('YYYY/MM/DD')
      break;
    case 1: // 上个月
      _minDate = moment(minDate.value).subtract(1, 'month').startOf('month').format('YYYY/MM/DD')
      _maxDate = moment(minDate.value).subtract(1, 'month').endOf('month').format('YYYY/MM/DD')
      break;
    case 2: // 下个月
      _minDate = moment(minDate.value).add(1, 'month').startOf('month').format('YYYY/MM/DD')
      _maxDate = moment(minDate.value).add(1, 'month').endOf('month').format('YYYY/MM/DD')
      break;
    case 3: // 指定年月
      _minDate = moment(dateStr).startOf('month').format('YYYY/MM/DD')
      _maxDate = moment(dateStr).endOf('month').format('YYYY/MM/DD')
      break;
  }
  minDate.value = new Date(_minDate)
  maxDate.value = new Date(_maxDate)
  showTitle.value = moment(minDate.value).format('YYYY年MM月')

  getSignInMothRecordFun(_minDate, type) // 获取月签到信息

  // 顶部切换按钮到边界不可点击
  // 时间在当前月的时候,下一个月不可点击
  nextDisabed.value = moment(maxDate.value).isSameOrAfter(moment().endOf('month').startOf('day'))
  // 5年前的时间可不点击
  preDisabed.value = moment(minDate.value).isSameOrBefore(moment().subtract(60, 'month').startOf('month').startOf('day'))
}
// 日历渲染函数
const formatter = (day) => {
  // const month = day.date.getMonth() + 1;
  const date = day.date.getDate();
  const _date = moment(day.date).format('YYYY-MM-DD');
  // 未签到
  if (notSignedInArr.value.includes(_date)) {
    day.className = 'not-sign-in-day'
  }
  // 已签到
  if (signedInArr.value.includes(_date)) {
    day.className = 'sign-in-day'
    day.text = ' '
  }
  // 今天
  if (today.value === _date) {
    day.className = 'today-day'
    day.topInfo = date
    day.text = ' '
    // 今天&已签到
    if (signedInArr.value.includes(_date)) {
      day.className = 'sign-in-today'
      day.topInfo = ' '
      day.text = ' '
    }
  }


  return day;
}
const toRecord = () => {
  router.push({
    name: 'signInRecord'
  })
}

</script>
<style  lang="less" scoped>
.sign-in-gift-index {
  // background: url("../../../assets/imgs/scenario/signInGift/pic1.png") no-repeat
  //   #efefef;
  // background-size: 100% auto;
  min-height: 100vh;
  // background: #efefef;
  :deep(.van-popup) {
    background-color: transparent;
  }
  .title-box {
    width: 100%;
    height: 110px;
    padding: 30px 0 0 27px;
    box-sizing: border-box;
    font-size: 11px;
    color: #666666;
    line-height: 1.5;
    h4 {
      font-size: 22px;
      color: #1f1c1b;
      font-weight: bold;
      font-style: italic;
    }
  }

  // 进度条
  .progress-box {
    margin: 0 15px 10px 15px;
    padding: 15px 12px 5px 12px;
    background: #ffffff;
    border-radius: 10px;

    .title-row {
      background: url("../../../assets/imgs/scenario/signInGift/pic10.png")
        no-repeat #fff;
      background-size: 100%;
      font-weight: 600;
      font-size: 17px;
      color: #000000;
      width: 70px;
      line-height: 1;
      padding-bottom: 10px;
      background-position: bottom;
      position: relative;
      z-index: 99;
    }

    ul {
      display: flex;
      overflow: auto;
      margin-top: -30px;

      .stage-start {
        width: 9px;
        height: 80px;
        position: relative;

        .circle {
          width: 9px;
          height: 9px;
          border: 3px solid #ff2b21;
          border-radius: 50%;
          background: #fff;
          box-sizing: border-box;
          position: absolute;
          top: 47px;
          z-index: 2;
        }
      }

      .stage-box {
        position: relative;
        flex-shrink: 0;
        width: 90px;
        height: 80px;
        display: flex;

        &.end-stage {
          width: 55px;
        }

        .bubble-tip {
          position: absolute;
          top: 3px;
          left: 80%;
          z-index: 2;
          width: 110px;
          height: 40px;
          background: url("../../../assets/imgs/scenario/signInGift/pic3.png")
            no-repeat;
          background-size: 100%;
          font-size: 9px;
          color: #ffffff;
          line-height: 1.8;
          text-align: center;
          opacity: 0;
        }

        .bubble-tip3 {
          position: absolute;
          left: 35%;
        }

        .line {
          position: absolute;
          top: 50px;
          width: 100%;
          height: 3px;
          background: #ffeceb;
        }

        .reach-line {
          background: #ff2b21;
          width: 0;
        }

        img {
          position: absolute;
          top: 39px;
          right: -5px;
          z-index: 1;
          width: 23px;
          height: auto;
        }

        .text {
          position: absolute;
          top: 65px;
          right: -15px;
          z-index: 1;
          font-weight: 400;
          font-size: 11px;
          color: #8d8d8d;
        }
      }
    }
  }

  // 日历样式
  .calendar-box {
    margin: 0 15px;

    header {
      padding: 0 26px 0 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #000000;
      background: url("../../../assets/imgs/scenario/signInGift/pic14.png")
        no-repeat;
      background-size: 100%;
      height: 55px;

      img {
        width: 14px;
        margin-right: 6px;
      }

      .text {
        padding-top: 10px;
        font-weight: 600;
        font-size: 17px;
        color: #000000;
      }
      .my-prize {
        display: flex;
        align-items: center;
      }
    }

    // 切换按钮
    .switch-button-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 60px;
      padding: 0px 15px 0 15px;
      box-sizing: border-box;
      font-size: 15px;
      color: #000000;
      font-weight: bold;
      background: #fff;
      line-height: 40px;

      .left {
        transform: rotate(180deg);
      }

      .disabled {
        color: #f0f2f5;
        pointer-events: none;
      }

      i {
        font-size: 20px;
      }
    }

    :deep(.van-calendar__header) {
      box-shadow: none;
    }

    :deep(.van-calendar) {
      // height: 380px;
    }
    :deep(.van-calendar__weekdays) {
      display: flex;
      align-items: center;
      height: 35px;
    }
    :deep(.van-calendar__day) {
      height: 40px;
    }

    :deep(.van-calendar__header-subtitle) {
      height: 0;
      overflow: hidden;
    }

    :deep(.sign-in-day) {
      position: relative;

      &::after {
        background: url("../../../assets/imgs/scenario/signInGift/pic7.png")
          no-repeat #fcd0c6;
        background-size: 14px auto;
        background-position: center;
        // content: "\2713";
        content: " ";
        // background: #fcd0c6;
        position: absolute;
        color: #fff;
        width: 27px;
        height: 27px;
        line-height: 27px;
        border-radius: 50%;
      }
    }
    :deep(.sign-in-today) {
      position: relative;

      &::after {
        background: url("../../../assets/imgs/scenario/signInGift/pic7.png")
          no-repeat #ff2b21;
        background-size: 14px auto;
        background-position: center;
        content: " ";
        // content: "\2713";
        // background: #ff2b21;
        position: absolute;
        color: #fff;
        width: 27px;
        height: 27px;
        line-height: 27px;
        border-radius: 50%;
      }
    }

    :deep(.not-sign-in-day) {
      position: relative;

      &::after {
        background: url("../../../assets/imgs/scenario/signInGift/pic8.png")
          no-repeat #f0f2f5;
        background-size: 14px auto;
        background-position: center;
        content: " ";
        // content: "\2717";
        // background: #f0f2f5;
        position: absolute;
        color: #fff;
        width: 27px;
        height: 27px;
        line-height: 27px;
        border-radius: 50%;
      }
    }

    :deep(.today-day) {
      position: relative;

      &::after {
        content: " ";
        background: #ff2b21;
        position: absolute;
        color: #fff;
        width: 27px;
        height: 27px;
        line-height: 27px;
        border-radius: 50%;
      }

      .van-calendar__top-info {
        font-size: 14px;
        color: #ffffff;
        position: absolute;
        top: 35%;
        z-index: 1;
      }
    }

    .calendar-footer {
      background: #fff;
      border-radius: 0 0 10px 10px;
      padding-top: 20px;

      button {
        margin: 0 20px 10px 20px;
        width: -webkit-fill-available;
      }
    }

    .dog-ear {
      display: flex;
      justify-content: flex-end;

      img {
        width: 30px;
      }
    }
  }

  .rule-box {
    margin: 0 auto;
    padding: 20px 0;
    width: 330px;

    h4 {
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      line-height: 3;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 11px;
        padding: 0 8px;
      }
    }

    p {
      font-weight: 400;
      font-size: 11px;
      color: #666666;
      line-height: 2;
      white-space: pre-line;
    }
  }
}
</style>
